import React from 'react';
import Doors from './Doors';
import mascot from '../../assets/images/mascot-hero.webp';
import { EV_FIRES_PER_100K, GAS_FIRES_PER_100K_LABEL } from '../../config/stats';

// Three of the mascot's worries, each stamped and popped into its receipt on a
// 12s loop, staggered so one is always mid-pop.
const BUBBLES = [
  { cls: 'fi-tb1', myth: "Won't it catch fire?", verdict: 'False', fact: `${EV_FIRES_PER_100K} fires per 100,000 EVs sold. Gas cars: about ${GAS_FIRES_PER_100K_LABEL}.` },
  { cls: 'fi-tb2', myth: "Isn't it all coal?", verdict: 'False', fact: "Even on the dirtiest grid, an EV's lifetime emissions beat a gas car's." },
  { cls: 'fi-tb3', myth: 'Range drops in the cold?', verdict: 'True', fact: 'It does, up to about 40% at 20°F with the heat on. Still plenty for a 37-mile day.' },
];

export default function Hero({ onSeeMyths }) {
  return (
    <section className="fi-hero" aria-labelledby="fi-hero-h">
      <div className="fi-wrap fi-hero-g">
        <div>
          <p className="fi-kick">Exclusive</p>
          <h1 className="fi-h1 fi-ant" id="fi-hero-h">
            <span className="fi-ln">Local man</span>
            <span className="fi-ln">still thinks</span>
            <span className="fi-ln"><span className="fi-hl">EVs catch fire.</span></span>
          </h1>
          <p className="fi-deck">Don't be offended. Most of us are idiots about electric vehicles. Pick a door.</p>
          <Doors onSeeMyths={onSeeMyths} />
        </div>
        <div className="fi-stage" aria-hidden="true">
          <div className="fi-mascot">
            <img src={mascot} width="380" height="552" alt="" fetchpriority="high" />
            {/* Lives in the mascot's box so the arrow lands on his face at any width. */}
            <span className="fi-thisguy" aria-hidden="true">
              this guy
              <svg viewBox="0 0 100 56" fill="none" stroke="#D7140F" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M4 48c26-2 58-14 88-40" /><path d="M79 10l13-2-4 12" /></svg>
            </span>
          </div>
          {BUBBLES.map((b) => (
            <div key={b.cls} className={`fi-tb ${b.cls}`}>
              <div className="fi-cell">
                <span className="fi-burst" />
                <span className="fi-myth">{b.myth}</span>
                <span className={`fi-hstamp${b.verdict === 'True' ? ' fi-hstamp--t' : ''}`}>{b.verdict}</span>
                <span className="fi-fact"><b>The receipts</b>{b.fact}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
